export default "__VITE_ASSET__D3F70aUq__"